import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { FINANCE_V2_HOSTNAME } from "../../../../common-utilities/utils/end-points";
import { FINANCE_REST_URLS } from "../../../../common-utilities/utils/end-points/finance-v2";
import ApprovalStageDetails from "../../approval-stage-details";

const PRApprovalCycles = ({ prId, createdBy, fallbackCurrent }) => {
  const [cycles, setCycles] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!prId) return;
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_APPROVALS}`,
      null,
      { documentId: prId, approvalType: "pr_approval" }
    )
      .then((response) => {
        if (Array.isArray(response)) {
          const sorted = [...response].sort(
            (a, b) => (b.cycleNumber || 1) - (a.cycleNumber || 1)
          );
          setCycles(sorted);
        }
      })
      .catch(() => {})
      .finally(() => setIsLoaded(true));
  }, [prId]);

  if (cycles.length === 0) {
    // Wait for the fetch to settle before declaring "no cycle" -- otherwise this flashes
    // on every PR (including ones with real history) for the instant before it resolves.
    if (!isLoaded) return null;
    if (!fallbackCurrent?.id) {
      // STORE-role PR submissions skip the approval workflow entirely (see
      // submitPRDirectly in the backend) -- no Approval document ever gets created, so
      // there's genuinely no cycle history to show here, not a failed fetch.
      return (
        <Typography color="text.secondary" sx={{ p: 2 }}>
          No approval cycle for this PR -- store submissions are approved automatically.
        </Typography>
      );
    }
    return <ApprovalStageDetails approvalDetails={fallbackCurrent} createdBy={createdBy} />;
  }

  if (cycles.length === 1) {
    return <ApprovalStageDetails approvalDetails={cycles[0]} createdBy={createdBy} />;
  }

  return (
    <div className="pr-approval-cycles">
      {cycles.map((cycle) => (
        <div key={cycle.id} className="pr-approval-cycle">
          <Typography className="section-title" sx={{ mt: 2 ,color: "green", fontWeight: "bold"}}>
            Cycle {cycle.cycleNumber || 1}
            {cycle.status !== "replaced" ? " — Current" : ""}
          </Typography>
          <ApprovalStageDetails approvalDetails={cycle} createdBy={createdBy} />
        </div>
      ))}
    </div>
  );
};

export default PRApprovalCycles;
